import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';
import {HttpStatusCode} from 'axios';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import {
} from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import {sysErr} from '../../../../common/commonGmn.js';
import {postRequest} from '../../../../common/backend.js';
import {searchCheck} from '../../../../common/common.js';

// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.LOGSEARCH_LIST.name, href: ''},
];

// ログ一覧Items
const gridItems = [
  {binding: 'opeTime', header: '操作日時', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'bizId', header: '業務ID', dataType: 'String', width: 100, isReadOnly: true},
  {binding: 'bizName', header: '業務名', dataType: 'String', width: 250, isReadOnly: true},
  {binding: 'opeId', header: '操作ID', dataType: 'String', width: 100, isReadOnly: true},
  {binding: 'opeName', header: '操作名', dataType: 'String', width: 100, isReadOnly: true},
  {binding: 'opeUser', header: '操作者ID', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'opeKind', header: '操作分類', dataType: 'String', width: 200, isReadOnly: true},
  {binding: 'opeItem', header: '操作対象項目', dataType: 'String', width: 250, isReadOnly: true},
  {binding: 'opeLabel', header: '操作項目ラベル', dataType: 'String', width: 250, isReadOnly: true},
  {binding: 'opeRemark', header: '操作項目補足', dataType: 'String', width: 250, isReadOnly: true},
  {binding: 'nonpubInfo', header: '非公開情報', dataType: 'String', width: 250, isReadOnly: true},
];

/**
 * ログ検索画面
 * 画面ID:SCZ1007
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      warningMessages: [],
    };

    this.gridRef = React.createRef();
  }

  /**
     * 初期処理
     */
  async componentDidMount() {
    await this._initialValue();
    this.doSearch();
  }

  /**
     * 画面項目初期化
     */
  _initialValue = async () => {
    try {
      await this.props.doSetInitValues({});
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doSetInitValues(null);
  }

  /**
   * クリア処理
   */
  _reset = async () => {
    await this.props.reset();
    this._initialValue();
    this.gridRef.current.setItemsSource([]);
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    const {values} = this.props;
    let _warningMessages = [];
    try {
      let _body = {
        searchConditionModel: values,
      };
      // リクエスト出す
      let _url = 'scz1007/search-log-list';
      const response = await postRequest(_url, _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['ログ一覧', '検索']},
          });
        }
        return;
      }
      let approvalList = response.data.approvalList || [];
      _warningMessages = searchCheck(approvalList);
      if (this.gridRef?.current) {
        this.gridRef.current.setItemsSource(approvalList);
      }
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'None',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: '300px', maxWidth: '100%', height: 'auto', width: 'auto'},
      isReadOnly: true,
    };

    let views = gridItems;
    const component = createComponents(views, true);
    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {component}
      </CustomFlexGrid>
    );
  }

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const {
      handleSubmit,
    } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="CSVoutput" item>
          <PositiveButton
            id="CSVoutput"
            onClick={handleSubmit(this.CSVoutput)}
            variant="contained"
            startIcon={<GetAppIcon/>}
          >
            <span>CSV出力</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };

  /**
 * CSV出力クリック時
 */
  CSVoutput = async () => {
    const {values} = this.props;
    let _warningMessages = [];
    try {
      let _body = {
        searchConditionModel: values,
      };
      // リクエスト出す
      let _url = 'scz1007/csv-log-list';
      const response = await postRequest(_url, _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['CSV', '出力']},
          });
        }
        return;
      }
      this.props.doShowMessage({
        message: {id: 'TKSCS00004I', values: ['CSV出力']},
      });
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keyBFA10111GMsg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Typography variant="h6" gutterBottom>&nbsp;</Typography>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="bizId" item xs={12} sm={3}>
                <Field
                  id="bizId"
                  name="bizId"
                  component={renderSelect}
                  className="fields"
                  label="業務ID"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                    shrink: true,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={1}>{'SCZ1001'}</MenuItem>
                  <MenuItem value={2}>{'SCZ1002'}</MenuItem>
                  <MenuItem value={3}>{'SCZ1003'}</MenuItem>
                  <MenuItem value={4}>{'SCZ1004'}</MenuItem>
                  <MenuItem value={5}>{'REF1001'}</MenuItem>
                  <MenuItem value={6}>{'REI1001'}</MenuItem>
                  <MenuItem value={7}>{'REA1001'}</MenuItem>
                  <MenuItem value={8}>{'REY1001'}</MenuItem>
                </Field>
              </Grid>
              <Grid key="biz_name" item xs={12} sm={3}>
                <Field
                  id="biz_name"
                  name="biz_name"
                  component={renderSelect}
                  className="fields"
                  label="業務名"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                    shrink: true,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={1}>{'ログイン'}</MenuItem>
                  <MenuItem value={2}>{'メニュー'}</MenuItem>
                  <MenuItem value={3}>{'ユーザ一覧'}</MenuItem>
                  <MenuItem value={4}>{'ユーザ詳細'}</MenuItem>
                  <MenuItem value={5}>{'屋内線定期調査シート集計表'}</MenuItem>
                  <MenuItem value={6}>{'区画番号異動リスト'}</MenuItem>
                  <MenuItem value={7}>{'屋内線定期調査毎年調査対象お客さま全使撤リスト'}</MenuItem>
                  <MenuItem value={8}>{'自家用化・低圧化お客さまリスト'}</MenuItem>
                </Field>
              </Grid>
              <Grid key="ope_id" item xs={12} sm={3}>
                <Field
                  id="ope_id"
                  name="ope_id"
                  component={renderSelect}
                  className="fields"
                  label="操作ID"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                    shrink: true,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={1}>{'01'}</MenuItem>
                  <MenuItem value={2}>{'02'}</MenuItem>
                  <MenuItem value={3}>{'03'}</MenuItem>
                  <MenuItem value={4}>{'04'}</MenuItem>
                </Field>
              </Grid>
              <Grid key="ope_name" item xs={12} sm={3}>
                <Field
                  id="ope_name"
                  name="ope_name"
                  component={renderSelect}
                  className="fields"
                  label="操作名"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                    shrink: true,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={1}>{'検索'}</MenuItem>
                  <MenuItem value={2}>{'登録'}</MenuItem>
                  <MenuItem value={3}>{'更新'}</MenuItem>
                  <MenuItem value={4}>{'承認'}</MenuItem>
                </Field>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="ope_user" item xs={12} sm={3}>
                <Field
                  id="ope_user"
                  name="ope_user"
                  component={renderTextField}
                  className="fields"
                  label="操作者ID"
                  fullWidth
                  type="text"
                  required={false}
                  validate={[
                  ]}
                />
              </Grid>
              <Grid key="ope_kind" item xs={12} sm={3}>
                <Field
                  id="ope_kind"
                  name="ope_kind"
                  component={renderSelect}
                  className="fields"
                  label="操作分類"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                    shrink: true,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={1}>{'社内ユーザーの画面操作'}</MenuItem>
                  <MenuItem value={2}>{'社外ユーザーの画面操作'}</MenuItem>
                  <MenuItem value={3}>{'バッチ処理'}</MenuItem>
                </Field>
              </Grid>
              <Grid key="opeTimeFrom" item xs={12} sm={3}>
                <Field
                  id="opeTimeFrom"
                  name="opeTimeFrom"
                  component={renderTextField}
                  className="fields"
                  label="操作日時（自）"
                  fullWidth
                  type="datetime-local"
                  required={false}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  validate={[
                  ]}
                />
              </Grid>
              <Grid key="opeTimeTo" item xs={12} sm={3}>
                <Field
                  id="opeTimeTo"
                  name="opeTimeTo"
                  component={renderTextField}
                  className="fields"
                  label="操作日時（至）"
                  fullWidth
                  type="datetime-local"
                  required={false}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  validate={[
                  ]}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
              spacing={1}
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="key1001List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles()(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
